import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Quote, Target } from 'lucide-react';

export const PersonalStory = () => {
  return (
    <>
      <div className="text-center mb-8 sm:mb-12">
        <div className="flex items-center justify-center gap-2 mb-4">
          <Quote className="w-5 h-5 sm:w-6 sm:h-6 text-emerald-600" />
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
            Meine persönliche Geschichte
          </h2>
          <Quote className="w-5 h-5 sm:w-6 sm:h-6 text-emerald-600" />
        </div>
        <p className="text-lg sm:text-xl text-gray-600">
          Warum ich KaufPause entwickelt habe
        </p>
      </div>

      <Card className="bg-white border-gray-200 shadow-lg">
          <CardContent className="p-4 sm:p-6 md:p-8">
            <div className="flex flex-col md:flex-row gap-6 sm:gap-8 items-start">
                {/* Text */}
                <div className="flex-1">
                  <div className="text-base sm:text-lg text-gray-700 leading-relaxed space-y-3 sm:space-y-4">
                    <p>
                      Als <strong>Videoeditor</strong> dachte ich ständig: "Ich brauche eine neue Festplatte, 
                      eine bessere Asset-Library oder das neueste Color-Grading-Panel." 
                      Aber ehrlich? Die meisten Sachen nutzte ich nur kurz oder gar nicht.
                    </p>
                    
                    <p>
                      Das <strong>PC-Lenkrad</strong> war der Wendepunkt - nach 5x benutzen verstaubte es in der Ecke. 
                      Und verkaufen? Viel schwieriger als kaufen! 🙄
                    </p>
                    
                    <div className="bg-emerald-50 p-4 sm:p-6 rounded-lg border-l-4 border-emerald-600 my-4 sm:my-6">
                      <div className="flex items-center gap-2 mb-2 sm:mb-3">
                        <Target className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-600" />
                        <h3 className="font-semibold text-emerald-800 text-sm sm:text-base">Die 30-Tage-Regel</h3>
                      </div>
                      <p className="text-emerald-700 text-sm sm:text-base">
                        Ich kannte die Regel, aber Excel-Listen führen? Keine Lust! Ich wollte ein 
                        <strong> einfaches, günstiges Tool</strong> - nicht wieder 100€/Jahr für eine komplizierte App.
                      </p>
                    </div>
                    
                    <p>
                      Deshalb entstand <strong>KaufPause</strong> - für alle, die  mit Impulskäufen kämpfen oder gekaufte Produkte nicht nutzen.
                    </p>
                    
                    <p className="text-emerald-700 font-medium bg-emerald-50 p-4 rounded-lg">
                      💡 Ja, es ist ironisch für eine Anti-Impulskauf-App Geld auszugeben. 
                      Aber du sparst dir vermutlich dadurch <strong>deutlich mehr</strong>, als sie kostet! 😊
                    </p>
                  </div>
                  
                  <div className="mt-6 text-right">
                    <p className="text-gray-600 italic font-medium">
                      — Tobias, Gründer von KaufPause
                    </p>
                  </div>
                </div>

                {/* Bild */}
                <div className="flex-shrink-0 order-first md:order-last">
                  <div className="relative">
                    <img 
                      src="/TobiasPoczesniokFotoKaufPause.webp" 
                      alt="Tobias Poczesniok - Gründer von KaufPause"
                      className="w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 rounded-2xl object-cover shadow-xl border-4 border-emerald-100 mx-auto md:mx-0"
                    />
                    <div className="absolute -bottom-2 -right-2 bg-emerald-600 text-white p-1.5 sm:p-2 rounded-full shadow-lg">
                      <Quote className="w-3 h-3 sm:w-4 sm:h-4" />
                    </div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
    </>
  );
}; 